import { createSlice } from "@reduxjs/toolkit";
import { fetchPartnerPdf, fetchRoles } from "./action";

const initialState: any = {
    roles: [],
    roleMessgae: '',
    statusType: '',
    editPdfDetail: {}
};


const configSlice = createSlice({
    name: "roles",
    initialState,
    reducers: {
        handleConfigError: (state) => {
            state.configMessage = "";
            state.configType = "";
        },
    },
    extraReducers: (builder) =>
        builder
        .addCase(fetchRoles.fulfilled, (state, action) => {
            state.roles = action?.payload?.data?.data || [];
            return state;
        })
        .addCase(fetchPartnerPdf.fulfilled, (state, action) => {
            state.editPdfDetail = action?.payload?.data?.data || {};
            return state;
        })
});

export default configSlice.reducer;